module.exports = __webpack_public_path__ + "img/close.69feb265.svg";